import {
  LinkedHashMapClassDesc1yxtovbec4ruk as LinkedHashMapClassDesc,
  ArrayListClassDesc2euexqfjnihq7 as ArrayListClassDesc,
  HashSetClassDesc1sva99tssxbb4 as HashSetClassDesc,
  LinkedHashSetClassDesc202cqq5740j6e as LinkedHashSetClassDesc,
  HashMapClassDesc33bep136pd9y6 as HashMapClassDesc,
  ArrayClassDesc2voesact8ugbc as ArrayClassDesc,
  PrimitiveArrayDescriptor3bvg9e2uulc3b as PrimitiveArrayDescriptor,
} from './CollectionDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { toNativeArrayImpl3ha7yn5cjhfpi as toNativeArrayImpl } from './Platform.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { PrimitiveKindndgbuh6is7ze as PrimitiveKind } from '../descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashMapSerializerClass;
function LinkedHashMapSerializer() {
  if (LinkedHashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.m16_1 = new (LinkedHashMapClassDesc())(kSerializer.az(), vSerializer.az());
      }
      az() {
        return this.m16_1;
      }
      n16(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      o16(_this__u8e3s4) {
        return this.n16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      p16(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.d2().m1();
      }
      q16(_this__u8e3s4) {
        return this.p16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r16() {
        return LinkedHashMap().f6();
      }
      s16(_this__u8e3s4) {
        return imul(_this__u8e3s4.p1(), 2);
      }
      t16(_this__u8e3s4) {
        return this.s16(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      u16(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v16(_this__u8e3s4) {
        return this.u16(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      w16(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashMap().gc(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x16(_this__u8e3s4) {
        return this.w16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      y16(_this__u8e3s4, size) {
      }
      z16(_this__u8e3s4, size) {
        return this.y16(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'LinkedHashMapSerializer');
    LinkedHashMapSerializerClass = $;
  }
  return LinkedHashMapSerializerClass;
}
var ArrayListSerializerClass;
function ArrayListSerializer() {
  if (ArrayListSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(element) {
        super(element);
        this.i17_1 = new (ArrayListClassDesc())(element.az());
      }
      az() {
        return this.i17_1;
      }
      r16() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().w();
      }
      j17(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      t16(_this__u8e3s4) {
        return this.j17(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      k17(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v16(_this__u8e3s4) {
        return this.k17(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      l17(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? ArrayList().b1(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x16(_this__u8e3s4) {
        return this.l17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m17(_this__u8e3s4, size) {
        return _this__u8e3s4.d8(size);
      }
      z16(_this__u8e3s4, size) {
        return this.m17(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      n17(_this__u8e3s4, index, element) {
        _this__u8e3s4.y3(index, element);
      }
      o17(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE();
        return this.n17(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ArrayListSerializer');
    ArrayListSerializerClass = $;
  }
  return ArrayListSerializerClass;
}
var HashSetSerializerClass;
function HashSetSerializer() {
  if (HashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.w17_1 = new (HashSetClassDesc())(eSerializer.az());
      }
      az() {
        return this.w17_1;
      }
      r16() {
        return HashSet().ha();
      }
      x17(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      t16(_this__u8e3s4) {
        return this.x17(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      y17(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v16(_this__u8e3s4) {
        return this.y17(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      z17(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashSet().ia(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x16(_this__u8e3s4) {
        return this.z17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      a18(_this__u8e3s4, size) {
      }
      z16(_this__u8e3s4, size) {
        return this.a18(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      b18(_this__u8e3s4, index, element) {
        _this__u8e3s4.v(element);
      }
      o17(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE();
        return this.b18(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HashSetSerializer');
    HashSetSerializerClass = $;
  }
  return HashSetSerializerClass;
}
var LinkedHashSetSerializerClass;
function LinkedHashSetSerializer() {
  if (LinkedHashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.d18_1 = new (LinkedHashSetClassDesc())(eSerializer.az());
      }
      az() {
        return this.d18_1;
      }
      r16() {
        // Inline function 'kotlin.collections.linkedSetOf' call
        return LinkedHashSet().v1();
      }
      e18(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      t16(_this__u8e3s4) {
        return this.e18(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      f18(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v16(_this__u8e3s4) {
        return this.f18(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      z17(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashSet().z1(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x16(_this__u8e3s4) {
        return this.z17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g18(_this__u8e3s4, size) {
      }
      z16(_this__u8e3s4, size) {
        return this.g18(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      h18(_this__u8e3s4, index, element) {
        _this__u8e3s4.v(element);
      }
      o17(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE();
        return this.h18(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'LinkedHashSetSerializer');
    LinkedHashSetSerializerClass = $;
  }
  return LinkedHashSetSerializerClass;
}
var HashMapSerializerClass;
function HashMapSerializer() {
  if (HashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.k18_1 = new (HashMapClassDesc())(kSerializer.az(), vSerializer.az());
      }
      az() {
        return this.k18_1;
      }
      n16(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      o16(_this__u8e3s4) {
        return this.n16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      p16(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.d2().m1();
      }
      q16(_this__u8e3s4) {
        return this.p16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r16() {
        return HashMap().n8();
      }
      l18(_this__u8e3s4) {
        return imul(_this__u8e3s4.p1(), 2);
      }
      t16(_this__u8e3s4) {
        return this.l18(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      m18(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      v16(_this__u8e3s4) {
        return this.m18(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      w16(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashMap().c9(_this__u8e3s4) : tmp0_elvis_lhs;
      }
      x16(_this__u8e3s4) {
        return this.w16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      n18(_this__u8e3s4, size) {
      }
      z16(_this__u8e3s4, size) {
        return this.n18(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE(), size);
      }
    }
    initMetadataForClass($, 'HashMapSerializer');
    HashMapSerializerClass = $;
  }
  return HashMapSerializerClass;
}
var ReferenceArraySerializerClass;
function ReferenceArraySerializer() {
  if (ReferenceArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(kClass, eSerializer) {
        super(eSerializer);
        this.p18_1 = kClass;
        this.q18_1 = new (ArrayClassDesc())(eSerializer.az());
      }
      az() {
        return this.q18_1;
      }
      r18(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      o16(_this__u8e3s4) {
        return this.r18((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      s18(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
      }
      q16(_this__u8e3s4) {
        return this.s18((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r16() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList().w();
      }
      t18(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      t16(_this__u8e3s4) {
        return this.t18(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      u18(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.p18_1);
      }
      v16(_this__u8e3s4) {
        return this.u18(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      v18(_this__u8e3s4) {
        return ArrayList().b1(asList(_this__u8e3s4));
      }
      x16(_this__u8e3s4) {
        return this.v18((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      w18(_this__u8e3s4, size) {
        return _this__u8e3s4.d8(size);
      }
      z16(_this__u8e3s4, size) {
        return this.w18(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      x18(_this__u8e3s4, index, element) {
        _this__u8e3s4.y3(index, element);
      }
      o17(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE();
        return this.x18(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ReferenceArraySerializer');
    ReferenceArraySerializerClass = $;
  }
  return ReferenceArraySerializerClass;
}
var MapLikeSerializerClass;
function MapLikeSerializer() {
  if (MapLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(keySerializer, valueSerializer) {
        super();
        this.a17_1 = keySerializer;
        this.b17_1 = valueSerializer;
      }
      c17(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().a1(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.i2_1;
        var last = progression.j2_1;
        var step_0 = progression.k2_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.d17(decoder, startIndex + index | 0, builder, false);
          }
           while (!(index === last));
      }
      t17(decoder, builder, startIndex, size) {
        return this.c17(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), startIndex, size);
      }
      d17(decoder, index, builder, checkIndex) {
        var key = decoder.y13(this.az(), index, this.a17_1);
        var tmp;
        if (checkIndex) {
          // Inline function 'kotlin.also' call
          var this_0 = decoder.b14(this.az());
          // Inline function 'kotlin.require' call
          if (!(this_0 === (index + 1 | 0))) {
            var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
            throw IllegalArgumentException().a1(toString(message));
          }
          tmp = this_0;
        } else {
          tmp = index + 1 | 0;
        }
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.n3(key)) {
          var tmp_2 = this.b17_1.az().s11();
          tmp_1 = !(tmp_2 instanceof PrimitiveKind());
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = decoder.x13(this.az(), vIndex, this.b17_1, getValue(builder, key));
        } else {
          tmp_0 = decoder.y13(this.az(), vIndex, this.b17_1);
        }
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.s3(key, value);
      }
      u17(decoder, index, builder, checkIndex) {
        return this.d17(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), checkIndex);
      }
      f17(encoder, value) {
        var size = this.o16(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.az();
        var composite = encoder.g15(descriptor, size);
        var iterator = this.q16(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = iterator;
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.collections.component1' call
          var k = element.e2();
          // Inline function 'kotlin.collections.component2' call
          var v = element.f2();
          var tmp = this.az();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          composite.c15(tmp, _unary__edvuaz, this.a17_1, k);
          var tmp_0 = this.az();
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          composite.c15(tmp_0, _unary__edvuaz_0, this.b17_1, v);
        }
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.f17(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'MapLikeSerializer');
    MapLikeSerializerClass = $;
  }
  return MapLikeSerializerClass;
}
var CollectionSerializerClass;
function CollectionSerializer() {
  if (CollectionSerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      q17(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      o16(_this__u8e3s4) {
        return this.q17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r17(_this__u8e3s4) {
        return _this__u8e3s4.m1();
      }
      q16(_this__u8e3s4) {
        return this.r17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
    }
    initMetadataForClass($, 'CollectionSerializer');
    CollectionSerializerClass = $;
  }
  return CollectionSerializerClass;
}
var CollectionLikeSerializerClass;
function CollectionLikeSerializer() {
  if (CollectionLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(elementSerializer) {
        super();
        this.s17_1 = elementSerializer;
      }
      f17(encoder, value) {
        var size = this.o16(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.az();
        var composite = encoder.g15(descriptor, size);
        var iterator = this.q16(value);
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.c15(this.az(), index, this.s17_1, iterator.o1());
          }
           while (inductionVariable < size);
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.f17(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      t17(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().a1(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.u17(decoder, startIndex + index | 0, builder, false);
          }
           while (inductionVariable < size);
      }
      u17(decoder, index, builder, checkIndex) {
        this.o17(builder, index, decoder.y13(this.az(), index, this.s17_1));
      }
    }
    initMetadataForClass($, 'CollectionLikeSerializer');
    CollectionLikeSerializerClass = $;
  }
  return CollectionLikeSerializerClass;
}
function readSize($this, decoder, builder) {
  var size = decoder.c14($this.az());
  $this.z16(builder, size);
  return size;
}
var AbstractCollectionSerializerClass;
function AbstractCollectionSerializer() {
  if (AbstractCollectionSerializerClass === VOID) {
    class $ {
      g17(decoder, previous) {
        var tmp1_elvis_lhs = previous == null ? null : this.x16(previous);
        var builder = tmp1_elvis_lhs == null ? this.r16() : tmp1_elvis_lhs;
        var startIndex = this.t16(builder);
        var compositeDecoder = decoder.l13(this.az());
        if (compositeDecoder.a14()) {
          this.t17(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
        } else {
          $l$loop: while (true) {
            var index = compositeDecoder.b14(this.az());
            if (index === -1)
              break $l$loop;
            this.e17(compositeDecoder, startIndex + index | 0, builder);
          }
        }
        compositeDecoder.m13(this.az());
        return this.v16(builder);
      }
      pz(decoder) {
        return this.g17(decoder, null);
      }
      e17(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
          this.u17(decoder, index, builder, checkIndex);
          tmp = Unit_instance;
        } else {
          tmp = $super.u17.call(this, decoder, index, builder, checkIndex);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer()]);
    AbstractCollectionSerializerClass = $;
  }
  return AbstractCollectionSerializerClass;
}
var PrimitiveArraySerializerClass;
function PrimitiveArraySerializer() {
  if (PrimitiveArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(primitiveSerializer) {
        super(primitiveSerializer);
        this.z18_1 = new (PrimitiveArrayDescriptor())(primitiveSerializer.az());
      }
      az() {
        return this.z18_1;
      }
      a19(_this__u8e3s4) {
        return _this__u8e3s4.b19();
      }
      t16(_this__u8e3s4) {
        return this.a19(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      c19(_this__u8e3s4) {
        return _this__u8e3s4.d19();
      }
      v16(_this__u8e3s4) {
        return this.c19(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      e19(_this__u8e3s4, size) {
        return _this__u8e3s4.f19(size);
      }
      z16(_this__u8e3s4, size) {
        return this.e19(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), size);
      }
      g19(_this__u8e3s4) {
        var message = 'This method lead to boxing and must not be used, use writeContents instead';
        throw IllegalStateException().o4(toString(message));
      }
      q16(_this__u8e3s4) {
        return this.g19((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
      }
      h19(_this__u8e3s4, index, element) {
        var message = 'This method lead to boxing and must not be used, use Builder.append instead';
        throw IllegalStateException().o4(toString(message));
      }
      o17(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE();
        return this.h19(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      r16() {
        return this.x16(this.i19());
      }
      l19(encoder, value) {
        var size = this.o16(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.z18_1;
        var composite = encoder.g15(descriptor, size);
        this.k19(composite, value, size);
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.l19(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      f17(encoder, value) {
        return this.l19(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      pz(decoder) {
        return this.g17(decoder, null);
      }
    }
    initMetadataForClass($, 'PrimitiveArraySerializer');
    PrimitiveArraySerializerClass = $;
  }
  return PrimitiveArraySerializerClass;
}
var PrimitiveArrayBuilderClass;
function PrimitiveArrayBuilder() {
  if (PrimitiveArrayBuilderClass === VOID) {
    class $ {
      m19(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.b19() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
          this.f19(requiredCapacity);
          tmp = Unit_instance;
        } else {
          tmp = $super.f19.call(this, requiredCapacity);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayBuilder');
    PrimitiveArrayBuilderClass = $;
  }
  return PrimitiveArrayBuilderClass;
}
//region block: exports
export {
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  HashMapSerializer as HashMapSerializer10v33y6rrzgrh,
  HashSetSerializer as HashSetSerializer1nieavib0jif1,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  PrimitiveArrayBuilder as PrimitiveArrayBuilder1tzna3i4eqw54,
  PrimitiveArraySerializer as PrimitiveArraySerializer6xcmeltdozbx,
  ReferenceArraySerializer as ReferenceArraySerializer3juj1vqolxkrs,
};
//endregion

//# sourceMappingURL=CollectionSerializers.mjs.map
